import {navigateTo} from '@/router'
import store from '@/store/index.js'

/**
 * 閉じるアイコン押下処理
 */
export function clickClose() {
  const screenTransitionSource = store.state.SuicaStore.screenTransitionSource
  const nextDisplayName = screenTransitionSource.displayName
  const nextFooterId = screenTransitionSource.footerId

  store.commit('updateFooterTab', nextFooterId)
  navigateTo({name: nextDisplayName})
}
